import styled from 'styled-components';
import { Skeleton } from 'ui/skeleton';
import { Tooltip } from 'ui/tooltip';
import { body2 } from 'ui/theme';

const Cell = styled.div`
  align-items: center;
  display: flex;
  ${body2}
`;

type Props = {
  isError: boolean;
  isLoading: boolean;
};

export const CustomEventsLoadableTableCell: React.FC<React.PropsWithChildren<Props>> = ({
  isError,
  isLoading,
  children,
}) => {
  if (isError)
    return (
      <Cell>
        <Tooltip
          tooltipContent={<span>Unable to load results, please refresh page and try again</span>}
        >
          --
        </Tooltip>
      </Cell>
    );
  if (isLoading)
    return (
      <Cell>
        <Skeleton />
      </Cell>
    );
  return <Cell>{children}</Cell>;
};
